import { render, staticRenderFns } from "./SalesApprovalAdd.vue?vue&type=template&id=e9519296&scoped=true"
import script from "./SalesApprovalAdd.vue?vue&type=script&lang=js"
export * from "./SalesApprovalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9519296",
  null
  
)

export default component.exports